import React, { useState } from 'react'
import { Form } from './Form'
import { AuthList } from './AuthList'
import { Accordion } from 'src/components/era-package'
import { faMoneyCheckDollarPen } from '@fortawesome/pro-regular-svg-icons'

export const Authorization = ({ list: initialList, ...statement }) => {

  const [expanded, setExpanded] = useState(true)
  const [list, setList] = useState(initialList || []);


	const handleFormSubmit = (newItems) => {
        console.log(list);
        console.log(initialList);
        console.log(newItems);
        setList(newItems); // replaces the list with newItems
	};

  return <>
    <Form {...statement} onSubmit={handleFormSubmit} />
    <Accordion title='Statement Authorization List'
      icon={faMoneyCheckDollarPen}
      expanded={expanded}
      onChange={(e, state) => setExpanded(state)}
      DetailsProps={{ sx: { p: 0 } }}
    >
      <AuthList authData={list} statement={statement} />
    </Accordion>
  </>
}